import type { ComponentProps } from 'react';
import type { Document } from 'react-pdf';

export interface OutlineEntry {
  pageNumber: number;
  title: string;
}

export type PDFDoc = Parameters<
  NonNullable<ComponentProps<typeof Document>['onLoadSuccess']>
>[0];

export type ReportKey = 'dis' | 'ficm' | 'icb' | 'icm' | 'rsm';

export const REPORT_TABS: { key: ReportKey; label: string }[] = [
  { key: 'dis', label: 'DIS' },
  { key: 'rsm', label: 'RSM' },
  { key: 'icb', label: 'ICB' },
  { key: 'icm', label: 'ICM' },
  { key: 'ficm', label: 'FICM' }
];
